export function recycleErrorMessage(error: unknown): string {
  const value = error as { message?: unknown; code?: string } | null;
  const message = typeof value?.message === 'string' ? value.message : '';
  if (value?.code === 'PGRST202' || value?.code === 'PGRST204' || value?.code === '42883') {
    return 'The recycle bin database update is required. Ask your administrator to apply the migration.';
  }
  if (value?.code === '42501') return 'Only owners and admins can manage the recycle bin.';
  if (value?.code?.startsWith('22'))
    return 'The record details are invalid. Refresh and review the selection.';
  if (
    value?.code === '23503' ||
    /foreign key|constraint|syntax error|relation .*does not exist/i.test(message)
  ) {
    return 'Related records prevent this action. No deletion was completed. Ask an administrator to review the dependencies.';
  }
  if (/failed to fetch|network|timeout/i.test(message) || error instanceof TypeError) {
    return 'Connection interrupted. Reopen the cleanup result to check what completed before retrying.';
  }
  return message || 'The operation could not be completed. Please try again.';
}

export function requireRecycleSuccess(data: unknown, error: unknown): void {
  if (error) throw new Error(recycleErrorMessage(error));
  if (!data || typeof data !== 'object' || !('success' in data) || data.success !== true) {
    throw new Error('The server did not confirm the operation. Refresh and review this record.');
  }
}
